import React from 'react';
import { useTranslation } from 'react-i18next';
import SectionTitle from '../SectionTitle';
import HorizontalLine from '../HorizontalLine';
import InvoicingAllRenters from './table-entry/InvoicingAllRenters';
import MeasuringDevices from './table-entry/MeasuringDevices';
import ExactMetering from './table-entry/ExactMetering';
import WirelessConsumptionMetering from './table-entry/WirelessConsumptionMetering';
import PriceGuarantee from './table-entry/PriceGuarantee';
import CustomerPortal from './table-entry/CustomerPortal';

const ServiceContent = () => {
  const { t } = useTranslation();
  return (
    <>
      <SectionTitle title={t('pageSummaryBasicServicesSectionTitle')} />
      <HorizontalLine />
      <InvoicingAllRenters />
      <HorizontalLine />
      <MeasuringDevices />
      <HorizontalLine />
      <ExactMetering />
      <HorizontalLine />
      <WirelessConsumptionMetering />
      <HorizontalLine />
      <PriceGuarantee />
      <HorizontalLine />
      <CustomerPortal />
      <HorizontalLine />
    </>
  );
};

export default ServiceContent;
